import { render, staticRenderFns } from "./CustomUi.vue?vue&type=template&id=5f351de5&scoped=true&"
import script from "./CustomUi.vue?vue&type=script&lang=js&"
export * from "./CustomUi.vue?vue&type=script&lang=js&"
import style0 from "./CustomUi.vue?vue&type=style&index=0&id=5f351de5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f351de5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f351de5')) {
      api.createRecord('5f351de5', component.options)
    } else {
      api.reload('5f351de5', component.options)
    }
    module.hot.accept("./CustomUi.vue?vue&type=template&id=5f351de5&scoped=true&", function () {
      api.rerender('5f351de5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/mindAr/components/CustomUi.vue"
export default component.exports